<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <i-menu-burger v-if="isShowMenu" @click.stop="showSidebar" />
        <vs-spacer />
        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>


<script>
import IMenuBurger from '@/assets/svg/icons/menu-burger.svg';
import ProfileDropDown      from './components/ProfileDropDown.vue';


export default {
  name:       'HeaderVertical',
  components: {
    ProfileDropDown,
    IMenuBurger,
  },
  props: {
    navbarColor: {
      type:    String,
      default: '#fff',
    },
    isShowMenu: {
      type:    Boolean,
      default: true,
    },
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return { 'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark')
                || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark') };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === 'default') return 'navbar-default';
      if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced';
      if (this.verticalNavMenuWidth) return 'navbar-full';

      return '';
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
  },
};
</script>
